<template>
  <div>
    <CaseTab :predmet_info="predmet_info" :current_tab="'Spisi'" />

    <!-- <SingleFileTagSwitch/> -->
    <div>
      <file-tag-upload @refresh="resetFileView" v-if="is_permission_inside('case.spis.create', false) " :folder_structure="all_files_rec" :group_id="inherit_data.group_url"  :spis_id="selected_spis.id_spis"/>
      
      <!-- <div
        v-if="is_permission_inside('case.spis.create', false)"
        class="upload-dokumenta-button"
        @click="uploadStyling"
      >
        {{ $t("page_2.page_2_3.add_btn") }}
        <div class="upload-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="16"
            viewBox="0 0 18 16"
          >
            <g>
              <g>
                <path
                  fill="#fff"
                  d="M3.995 5.15a.738.738 0 0 1 .16-.805L8.29.214a.742.742 0 0 1 1.046 0l4.135 4.131a.74.74 0 0 1-.522 1.261h-1.807v5.357a.984.984 0 0 1-.985.983H7.47a.984.984 0 0 1-.984-.983V5.606H4.678a.74.74 0 0 1-.683-.456zm13.749 3.351v3.71C17.744 14.3 16.042 16 13.95 16H3.677a3.796 3.796 0 0 1-3.793-3.79V8.502a.888.888 0 0 1 1.776 0v3.71c0 1.11.904 2.015 2.017 2.015H13.95a2.019 2.019 0 0 0 2.018-2.016V8.501a.887.887 0 0 1 1.776 0z"
                />
              </g>
            </g>
          </svg>
        </div>
      </div> -->
      <div class="case-spisi">
        <div class="spisi-left-above">
          <draggable
            :sort="false"
            class="case-spisi-folders-line spisi-folders-line"
          >
            <div
              class="section-square kreiraj-spis"
              v-if="is_permission_inside('case.spis.create')"
              @click="switchTab('novi-spis')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="46"
                height="44"
                viewBox="0 0 46 44"
              >
                <g>
                  <g>
                    <path
                      fill="#b8b8c1"
                      d="M39.943 11.447v.191h.305a5.783 5.783 0 0 1 5.777 5.776v20.81A5.783 5.783 0 0 1 40.248 44H5.778A5.783 5.783 0 0 1 0 38.225V5.736A5.783 5.783 0 0 1 5.777-.039h11.127A5.792 5.792 0 0 1 21.17 1.84l3.378 3.694c.08.087.193.137.311.137h9.308a5.783 5.783 0 0 1 5.777 5.776zM10.442 38.225v-20.81a5.783 5.783 0 0 1 5.777-5.777h22.088v-.191a4.146 4.146 0 0 0-4.142-4.14h-9.308a2.065 2.065 0 0 1-1.518-.67l-3.377-3.694a4.153 4.153 0 0 0-3.058-1.347H5.777a4.146 4.146 0 0 0-4.142 4.14v32.489a4.146 4.146 0 0 0 4.142 4.14H6.3a4.146 4.146 0 0 0 4.143-4.14zm5.777-24.952a4.146 4.146 0 0 0-4.142 4.14v20.812a5.76 5.76 0 0 1-1.753 4.14h29.924a4.146 4.146 0 0 0 4.142-4.14V17.414a4.146 4.146 0 0 0-4.142-4.14zm5.356 14.547c0-.452.366-.818.817-.818h5.024v-5.02a.818.818 0 0 1 1.635 0v5.02h5.023a.817.817 0 1 1 0 1.635h-5.023v5.022a.817.817 0 1 1-1.635 0v-5.022h-5.024a.818.818 0 0 1-.817-.817z"
                    />
                  </g>
                </g>
              </svg>
              <div>{{ $t("page_2.page_2_3.add_new") }}</div>
            </div>
            <div
              class="section-square spis-folder"
              v-for="fold in rootSpisi"
              :key="fold.id_spis"
              :id="fold.id_spis"
              @dragover="folderHoverSpis(fold)"
              @dragleave="folderHoverSpis(null)"
              @dragend="moveFile(activityFile)"
              @click="routeToSpis(fold.id_spis)"
            >
              <div
                :class="[
                  'zadnji-spis-dot',
                  'indikator',
                  !predmet_info.is_archived
                    ? 'i-g'
                    : predmet_info.is_archived && !predmet_info.is_destroyed
                    ? 'i-g-archived'
                    : 'i-g-destroyed',
                ]"
              ></div>
              <svg
                version="1.0"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 137 113.1"
                style="enable-background: new 0 0 137 113.1"
                xml:space="preserve"
              >
                <path
                  class="st0"
                  d="M120.2,109.7H56.4c-4.3,0-7.8-2.9-7.8-6.4l9-73.5c0-3.5,3.5-6.4,7.8-6.4h63.8c4.3,0,7.8,2.9,7.8,6.4l-9,73.5
                C127.9,106.8,124.5,109.7,120.2,109.7z"
                />
                <g>
                  <path
                    class="st1"
                    d="M118.4,110h-65c-4.4,0-7.9-3.2-7.9-7.2l-2.9-82.5c0-4,3.5-7.2,7.9-7.2h65c4.4,0,7.9,3.2,7.9,7.2l2.9,82.5
                  C126.3,106.8,122.8,110,118.4,110z"
                  />
                  <path
                    class="st0"
                    d="M118.4,111.5h-65c-5.2,0-9.4-3.9-9.4-8.7l-2.9-82.5c0-4.8,4.2-8.7,9.4-8.7h65c5.2,0,9.4,3.9,9.4,8.7l2.9,82.5
                  C127.8,107.6,123.6,111.5,118.4,111.5z M50.5,14.6c-3.5,0-6.4,2.5-6.4,5.7l2.9,82.5c0,3.2,2.9,5.7,6.4,5.7h65
                  c3.5,0,6.4-2.5,6.4-5.7l-2.9-82.5c0-3.2-2.9-5.7-6.4-5.7H50.5z"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M101.9,98.4H38.1c-4.3,0-7.8-3.2-7.8-7.2l-11-82.5c0-4,3.5-7.2,7.8-7.2h63.8c4.3,0,7.8,3.2,7.8,7.2l11,82.5
                  C109.6,95.1,106.2,98.4,101.9,98.4z"
                  />
                  <path
                    class="st0"
                    d="M101.9,99.9H38.1c-5.1,0-9.2-3.8-9.3-8.6l-11-82.5V8.7C17.9,3.9,22,0,27.1,0h63.8c5.1,0,9.2,3.8,9.3,8.6
                  l11,82.5v0.1C111.1,96,107,99.9,101.9,99.9z M20.9,8.6l11,82.5v0.1c0,3.1,2.8,5.7,6.3,5.7h63.8c3.4,0,6.2-2.5,6.3-5.6l-11-82.5V8.7
                  c0-3.1-2.8-5.7-6.3-5.7H27.1C23.7,3,20.9,5.5,20.9,8.6z"
                  />
                </g>
                <g>
                  <g>
                    <path
                      class="st2"
                      d="M107,29.6H59.3l-9.5-11.3c-0.3-0.3-0.7-0.5-1.2-0.5H10.4C4.6,17.8,0,22.5,0,28.2l10.5,74.4
                    c0,5.7,4.6,10.4,10.4,10.5h96.6c5.7-0.1,10.4-4.7,10.4-10.5L117.3,40C117.3,34.3,112.7,29.6,107,29.6z"
                    />
                  </g>
                </g>
              </svg>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    {{ fold.ime }}
                  </div>
                </template>
                <div class="info-tooltip">
                  {{ fold.opis_spisa }}
                </div>
              </v-tooltip>
            </div>

            <div
              class="section-square radni-dokumenti"
              v-if="is_permission_inside('case.radni.read', false)"
              @click="switchTab('radni')"
            >
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 137 113.1"
                enable-background="new 0 0 137 113.1"
                xml:space="preserve"
              >
                <path
                  fill="#E5E9F4"
                  d="M120.2,109.7H56.4c-4.3,0-7.8-2.9-7.8-6.4l9-73.5c0-3.5,3.5-6.4,7.8-6.4h63.8c4.3,0,7.8,2.9,7.8,6.4l-9,73.5
                  C127.9,106.8,124.5,109.7,120.2,109.7z"
                />
                <g>
                  <path
                    fill="#FFFFFF"
                    d="M118.4,110h-65c-4.4,0-7.9-3.2-7.9-7.2l-2.9-82.5c0-4,3.5-7.2,7.9-7.2h65c4.4,0,7.9,3.2,7.9,7.2l2.9,82.5
                    C126.3,106.8,122.8,110,118.4,110z"
                  />
                  <path
                    fill="#E5E9F4"
                    d="M118.4,111.5h-65c-5.2,0-9.4-3.9-9.4-8.7l-2.9-82.5c0-4.8,4.2-8.7,9.4-8.7h65c5.2,0,9.4,3.9,9.4,8.7
                    l2.9,82.5C127.8,107.6,123.6,111.5,118.4,111.5z M50.5,14.6c-3.5,0-6.4,2.5-6.4,5.7l2.9,82.5c0,3.2,2.9,5.7,6.4,5.7h65
                    c3.5,0,6.4-2.5,6.4-5.7l-2.9-82.5c0-3.2-2.9-5.7-6.4-5.7H50.5z"
                  />
                </g>
                <g>
                  <path
                    fill="#FFFFFF"
                    d="M101.9,98.4H38.1c-4.3,0-7.8-3.2-7.8-7.2l-11-82.5c0-4,3.5-7.2,7.8-7.2h63.8c4.3,0,7.8,3.2,7.8,7.2l11,82.5
                    C109.6,95.1,106.2,98.4,101.9,98.4z"
                  />
                  <path
                    fill="#E5E9F4"
                    d="M101.9,99.9H38.1c-5.1,0-9.2-3.8-9.3-8.6l-11-82.5V8.7C17.9,3.9,22,0,27.1,0h63.8c5.1,0,9.2,3.8,9.3,8.6
                    l11,82.5v0.1C111.1,96,107,99.9,101.9,99.9z M20.9,8.6l11,82.5v0.1c0,3.1,2.8,5.7,6.3,5.7h63.8c3.4,0,6.2-2.5,6.3-5.6l-11-82.5V8.7
                    c0-3.1-2.8-5.7-6.3-5.7H27.1C23.7,3,20.9,5.5,20.9,8.6z"
                  />
                </g>
                <g>
                  <g>
                    <path
                      fill="#E9A422"
                      d="M107,29.6H59.3l-9.5-11.3c-0.3-0.3-0.7-0.5-1.2-0.5H10.4C4.6,17.8,0,22.5,0,28.2l10.5,74.4
                      c0,5.7,4.6,10.4,10.4,10.5h96.6c5.7-0.1,10.4-4.7,10.4-10.5L117.3,40C117.3,34.3,112.7,29.6,107,29.6z"
                    />
                  </g>
                </g>
              </svg>
              <div>{{ $t("page_2.page_2_3.fold_1") }}</div>
            </div>
            <div
              class="section-square popratna-dokumentacija"
              v-if="is_permission_inside('case.side.read', false)"
              @click="switchTab('popratni')"
            >
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 137 113.1"
                enable-background="new 0 0 137 113.1"
                xml:space="preserve"
              >
                <path
                  fill="#E4E8F3"
                  d="M120.2,109.7H56.4c-4.3,0-7.8-2.9-7.8-6.4l9-73.5c0-3.5,3.5-6.4,7.8-6.4h63.8c4.3,0,7.8,2.9,7.8,6.4l-9,73.5
                  C127.9,106.8,124.5,109.7,120.2,109.7z"
                />
                <g>
                  <path
                    fill="#FFFFFF"
                    d="M118.4,110h-65c-4.4,0-7.9-3.2-7.9-7.2l-2.9-82.5c0-4,3.5-7.2,7.9-7.2h65c4.4,0,7.9,3.2,7.9,7.2l2.9,82.5
                    C126.3,106.8,122.8,110,118.4,110z"
                  />
                  <path
                    fill="#E4E8F3"
                    d="M118.4,111.5h-65c-5.2,0-9.4-3.9-9.4-8.7l-2.9-82.5c0-4.8,4.2-8.7,9.4-8.7h65c5.2,0,9.4,3.9,9.4,8.7
                    l2.9,82.5C127.8,107.6,123.6,111.5,118.4,111.5z M50.5,14.6c-3.5,0-6.4,2.5-6.4,5.7l2.9,82.5c0,3.2,2.9,5.7,6.4,5.7h65
                    c3.5,0,6.4-2.5,6.4-5.7l-2.9-82.5c0-3.2-2.9-5.7-6.4-5.7H50.5z"
                  />
                </g>
                <g>
                  <path
                    fill="#FFFFFF"
                    d="M101.9,98.4H38.1c-4.3,0-7.8-3.2-7.8-7.2l-11-82.5c0-4,3.5-7.2,7.8-7.2h63.8c4.3,0,7.8,3.2,7.8,7.2l11,82.5
                    C109.6,95.1,106.2,98.4,101.9,98.4z"
                  />
                  <path
                    fill="#E4E8F3"
                    d="M101.9,99.9H38.1c-5.1,0-9.2-3.8-9.3-8.6l-11-82.5V8.7C17.9,3.9,22,0,27.1,0h63.8c5.1,0,9.2,3.8,9.3,8.6
                    l11,82.5v0.1C111.1,96,107,99.9,101.9,99.9z M20.9,8.6l11,82.5v0.1c0,3.1,2.8,5.7,6.3,5.7h63.8c3.4,0,6.2-2.5,6.3-5.6l-11-82.5V8.7
                    c0-3.1-2.8-5.7-6.3-5.7H27.1C23.7,3,20.9,5.5,20.9,8.6z"
                  />
                </g>
                <g>
                  <g>
                    <path
                      fill="#7E48B7"
                      d="M107,29.6H59.3l-9.5-11.3c-0.3-0.3-0.7-0.5-1.2-0.5H10.4C4.6,17.8,0,22.5,0,28.2l10.5,74.4
                      c0,5.7,4.6,10.4,10.4,10.5h96.6c5.7-0.1,10.4-4.7,10.4-10.5L117.3,40C117.3,34.3,112.7,29.6,107,29.6z"
                    />
                  </g>
                </g>
              </svg>
              <div>{{ $t("page_2.page_2_3.fold_2") }}</div>
            </div>
          </draggable>
        </div>
      </div>
      <div v-if="is_permission_inside('case.spis.item.read', false)">
        <div class="case-spisi">
          <div class="file-switch-wrapp" @click="toggleFileView">
            <button class="file-switch-view">
              <span class="line"></span>
              <span class="line"></span>
              <span class="line"></span>
              <span class="line"></span>
              <span class="sr-only">Toggle menu</span>
            </button>
            {{ getViewTypeText }}
          </div>
        </div>
        <TreeViewerVue
          v-if="inherit_data.folder_id != null && active_view_type == 0"
          ref="treeViewer"
          :group_type="0"
          :duplicatable="false"
          permission_starter="case.spis"
          :selected_spis="selected_spis"
          :folder_id="inherit_data.folder_id"
          :group_url="inherit_data.group_url"
          @loaded-docs="getDocs"
          :spis_hover="spis_hovered"
          :can_share="true"
          @merge-docs="getMergeDocs"
          view_name="spisi"
          @uploadStyling="uploadStyling"
          @openSharePopup="openSharePopup"
          :tagged_files = "all_files_tags"
        ></TreeViewerVue>
        <BlockViewer
          v-if="inherit_data.folder_id != null && active_view_type == 1"
          :key="treemenu_counter"
          :group_type="0"
          :duplicatable="false"
          permission_starter="case.spis"
          :selected_spis="selected_spis"
          :spis_hover="spis_hovered"
          :folder_id="inherit_data.folder_id"
          :group_url="inherit_data.group_url"
          @loaded-docs="getDocs"
          :pdf_merge_file_list="pdf_merge_file_list"
          :all_files_rec="all_files_rec"
          view_name="spisi"
          :movable="false"
          @uploadStyling="uploadStyling"
          :can_share="true"
        >
        </BlockViewer>
      </div>
      <div v-else class="case-spisi-single">
        <div class="spisi-right">
          <div class="detalji-spisa section">
            <div class="section-title">
              {{ $t("page_2.page_2_3.detail_1.title") }}
            </div>
            <!-- TODO dodati link na edit spisa -->
            <div class="detalji-spisa-top">
              <img class="doc-icon" src="@/assets/img/folder_icon.svg" />
              <div class="inside-folder-txts">
                <div class="inside-folder-title">{{ selected_spis.ime }}</div>
              </div>
            </div>
            <div class="detalji-spisa-list">
              <div class="detalji-spisa-end">
                <div class="case-info-item">
                  <div class="case-info-item-title">
                    {{ $t("page_2.page_2_3.detail_1.tl_3") }}:
                  </div>
                  <div class="case-info-item-info">
                    {{ selected_spis.opis_spisa }}
                  </div>
                </div>
                <div class="case-info-item">
                  <div class="case-info-item-title">
                    {{ $t("page_2.page_2_3.detail_1.tl_4") }}
                  </div>
                  <div class="case-info-item-info">
                    <router-link
                      v-if="selected_spis.institucija != null"
                      :to="
                        '/osobe/institucije/' + selected_spis.institucija.uid
                      "
                      >{{ selected_spis.institucija.naziv }}
                    </router-link>
                  </div>
                </div>
                <!-- Vidjeti kak bi izlgedalo s stvarnim vrijednostima -->
                <div class="case-info-item">
                  <div class="case-info-item-title">
                    {{ $t("page_2.page_2_3.detail_1.tl_5") }}:
                  </div>
                  <div class="case-info-item-info">
                    <div
                      class="info-item-element"
                      v-for="(
                        sudionik, key
                      ) in selected_spis.spis_sudionici_connector"
                      :key="key"
                    >
                      <router-link
                        :to="'/osobe/leg-body/' + sudionik.sluzbena_osoba.uid"
                        >{{ sudionik.sluzbena_osoba.ime }}
                        {{ sudionik.sluzbena_osoba.prezime }}</router-link
                      >
                    </div>
                  </div>
                </div>
                <div class="case-info-item">
                  <div class="case-info-item-title">
                    {{ $t("page_2.page_2_3.detail_1.tl_6") }}:
                  </div>
                  <div class="case-info-item-info">
                    {{ selected_spis.posl_br }}
                  </div>
                </div>
                <div
                  v-if="
                    selected_spis.postupak.naziv != undefined &&
                    selected_spis.postupak.naziv != null
                  "
                  class="case-info-item"
                >
                  <div class="case-info-item-title">
                    {{ $t("page_2.page_2_3.detail_1.tl_7") }}:
                  </div>
                  <div class="case-info-item-info">
                    {{ selected_spis.postupak.naziv }}
                  </div>
                </div>
                <div
                  class="detalji-buttons"
                  v-if="is_permission_inside('case.spis.edit')"
                  @click="switchTab('spisi/' + selected_spis.id_spis + '/edit')"
                >
                  <div class="print-button icon-button" @click="spisToPDF()">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="18"
                      viewBox="0 0 16 13"
                    >
                      <g>
                        <g>
                          <path
                            fill="#7b7b8a"
                            d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                          />
                        </g>
                      </g>
                    </svg>
                    <span>Uredi</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="newFilePop" width="540">
      <v-card>
        <v-card-title class="headline grey lighten-2" id="main-file-upload">
          {{ $t("page_2.page_2_3.upload_pop.title") }}
        </v-card-title>
        <tree-folders
          :depth="0"
          :item="all_files_rec"
          :accessToken="accessToken"
          @node-click="setUploadFolder"
          :smjer="smjer"
          :key="keyster_files"
        ></tree-folders>
        <!-- <v-card-title class="headline grey lighten-2">
            Novi dokument
          </v-card-title> -->
        <div>
          <div
            class="flex w-full h-screen items-center justify-center text-center drop-document-main-wrapper"
            id="app"
          >
            <div
              class="p-12 bg-gray-100 border border-gray-300"
              @dragover="dragover"
              @dragleave="dragleave"
              @drop="drop"
            >
              <div class="loading-spinner"></div>
              <input
                type="file"
                multiple
                name="fields[assetsFieldHandle][]"
                id="assetsFieldHandle"
                class="w-px h-px opacity-0 overflow-hidden absolute drag-drop"
                @change="onChange"
                ref="file"
                accept=".pdf, .zip"
              />

              <label
                for="assetsFieldHandle"
                class="block cursor-pointer drop-document-area"
              >
                <div>
                  <div class="select-file-message-wrapper">
                    <div class="select-file-message">
                      {{ $t("page_2.page_2_3.upload_pop.instruction") }}
                    </div>
                  </div>
                  <div class="button-select-file-wrapper">
                    <div class="button-default button-select-file">
                      {{ $t("page_2.page_2_3.upload_pop.btn_1") }}
                    </div>
                  </div>
                </div>
              </label>
              <div class="opening-folder opening-radni-dokumenti section">
                <div class="inside-radni-dokumenti">
                  <draggable
                    :class="filelist.length > 3 ? 'row-multiple' : 'row'"
                    :sort="false"
                  >
                    <div v-for="upFile in filelist" :key="upFile.id">
                      <div
                        :class="[
                          filelist.length > 3
                            ? 'radni-dokument-inside-multiple'
                            : 'radni-dokument-inside',
                          'preneseni-dokument',
                        ]"
                        draggable="true"
                      >
                        <div
                          :class="[
                            filelist.length > 3
                              ? 'document-image-wrapper-multiple'
                              : 'document-image-wrapper',
                          ]"
                        >
                          <img
                            class="preneseni-dokument-image"
                            :src="returnFileType(upFile.name)"
                          />
                          <div
                            v-show="filelist.length < 4"
                            class="remove-document"
                            @click="deleteFileInSpis(upFile)"
                          >
                            <span>X</span>
                          </div>
                        </div>
                        <div class="preneseni-dokument-title">
                          {{ upFile.name }}
                        </div>

                        <div
                          v-show="filelist.length > 3"
                          class="remove-document-multiple"
                          @click="deleteFileInSpis(upFile)"
                        >
                          <span>X</span>
                        </div>
                      </div>
                    </div>
                  </draggable>
                </div>
              </div>
            </div>
          </div>
        </div>
        <v-card-actions>
          <div class="button-upload-wrapper">
            <div
              class="button-default button-create"
              @click="!is_waiting_on_insert ? addNewUploadFile() : ''"
            >
              <svg
                v-if="is_waiting_on_insert"
                class="update-event-spin"
                viewBox="0 0 50 50"
              >
                <circle
                  class="path"
                  cx="25"
                  cy="25"
                  r="20"
                  fill="none"
                  stroke-width="8"
                ></circle>
              </svg>
              <span v-else>{{ $t("page_2.page_2_3.upload_pop.btn_2") }}</span>
            </div>
          </div>
        </v-card-actions>
      </v-card>
      <v-snackbar
        v-model="snackbar"
        :timeout="snackTimeout"
        color="snack-custom-dark-blue"
        elevation="24"
      >
        {{ snackText }}
        <div v-for="(od, key) in odbacene" :key="key">{{ od.name }}</div>
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            {{ $t("repetitive.okay") }}
          </v-btn>
        </template>
      </v-snackbar>
    </v-dialog>
  </div>
</template>

<script>
import share from "@/apiCallers/promise_handler_db/sharepoint";
import $ from "jquery";
import gsap from "gsap";
import TreeMenu from "@/components/generalComponents/TreeMenu.vue";
import TreeFolders from "@/components/generalComponents/TreeFolders.vue";
import CaseTab from "@/components/caseComponents/CaseTab.vue";
import draggable from "vuedraggable";
import person from "@/apiCallers/promise_handler_db/person";
import { getCaseData } from "@/router/case/handler";
import permissioner from "@/services/permissioner.js";
import DataLoader from "@/components/generalComponents/DataLoader";
import TreeViewerVue from "../../../../components/generalComponents/FileViewer/TreeViewer.vue";
import BlockViewer from "../../../../components/generalComponents/FileViewer/BlockViewer.vue";
import FileTagUpload from '../../../../components/fileManagement/FileTagUpload.vue';
import fileTaggingHandler from "../../../../apiCallers/promise_handler_db/fileTagging"
import SingleFileTagSwitch from "../../../../components/fileManagement/SingleFileTagSwitch.vue";


export default {
  components: {
    TreeMenu,
    TreeFolders,
    draggable,
    CaseTab,
    TreeViewerVue,
    DataLoader,
    BlockViewer,
    FileTagUpload,
    SingleFileTagSwitch
  },
  data() {
    return {
      inherit_data: {
        folder_id: null,
        group_url: null,
      },
      spis_hovered: null,
      // 0 - tree view,
      // 1 - block type
      active_view_type: 0,

      smjer: true,
      sort_type: 0,
      keyster_files: 1,

      //moving
      moving_file: {
        parentReference: {
          id: "",
        },
        name: "",
      },
      //SNACK PROPERTIES
      snackbar: false,
      snackTimeout: 10000,
      odbacene: [],
      snackText: "",
      //SNACK PROPERTIES
      //upload folder start
      newDirectoryName: "",
      newDirectoryParentId: "",
      newFolderPop: false,
      uploadNode: null,
      //upload folder end
      overlay: false,
      overlay_progress: 0,
      newFilePop: false,
      upload_fold_model: false,
      selected_upload_folder: {},
      order_by_tekst: this.$t("page_2.page_2_3.f_desc"),
      selected_spis: {},
      treemenu_counter: 1,

      delete_screen: false,
      activityFile: null,
      multi_file_list: [],
      accessToken: "",
      folders: [],
      predmet_info: { ime_predmeta: "", broj_predmeta: "" },
      rootSpisi: [],
      filelist: [],
      pdf_merge_file_list: [],

      file_upload_text: "Upload",
      is_waiting_on_insert: false,

      all_files_rec: null,
      all_files_tags : [],
    };
  },
  computed: {
    getViewTypeText: function () {
      if (this.active_view_type == 0) {
        return this.$t("billing_page.tree_view");
      } else {
        return this.$t("billing_page.block_view");
      }
    },
  },
  async created() {
    this.accessToken = this.$store.state.aToken;

    
    await getCaseData(this.$route.params.uid).then(async (response) => {
      if (!this.is_permission_inside("case.spis.read")) {
        this.$router.push("/case/" + this.$route.params.uid + "/");
      }

      let all_together = response;
      this.predmet_info = response;

      this.rootSpisi = all_together.spis;
      console.log("ROOT SPISI", this.rootSpisi);
      if (this.rootSpisi.length > 0) {
        let i = 0;
        let idx_sp = i;

        this.rootSpisi.forEach((p) => {
          if (p.id_spis == this.$route.params.sid) {
            idx_sp = i;
          }
          i++;
        });

        this.inherit_data.group_url = this.$route.params.uid;
        this.inherit_data.folder_id = this.rootSpisi[idx_sp].id_spis;

        this.selected_spis = this.rootSpisi[idx_sp];
        this.selected_upload_folder = this.rootSpisi[idx_sp].id_spis;

        setTimeout(function () {
          let first = idx_sp + 2;
          $(".section-square:nth-of-type(" + first + ")").addClass(
            "aktivan-spis-folder"
          );
        }, 500);
      }
    });
  },

  methods: {
   
    openSharePopup(selected_file_id) {
      console.log("file will be shared", selected_file_id);
    },
    toggleFileView: function () {
      if (this.active_view_type == 0) {
        this.active_view_type = 1;
      } else {
        this.active_view_type = 0;
      }
      $(".file-switch-view").toggleClass("is-active");
    },
    getDocs: function (all_files) {
      this.all_files_rec = all_files;
    },
    getMergeDocs: function (all_files) {
      this.pdf_merge_file_list = all_files;
    },
    is_permission_inside(wanted_permission, assistent_check = true) {
      return permissioner.check_case_permsision(
        wanted_permission,
        assistent_check
      );
    },

    //FOLDER DROP ON FOLDER
    moveFile(node) {
      if (this.multi_file_list.length == 0) {
        this.multi_file_list.push(node);
      }
      let move_counter = 0;
      for (let i = 0; i < this.multi_file_list.length; i++) {
        let active_move_file = this.multi_file_list[i];
        if (
          active_move_file.parentReference.id !=
            this.moving_file.parentReference.id &&
          this.moving_file.parentReference.id != ""
        ) {
          move_counter++;
          this.moving_file.name = active_move_file.name;
          var path = "/drive/items/" + active_move_file.id;

          share
            .moveDriveItem(
              this.accessToken,
              this.$route.params.uid,
              active_move_file.parentReference.id,
              path,
              this.moving_file
            )
            .then(() => {
              if (i + 1 == this.multi_file_list.length) {
                this.multi_file_list = [];
                if (
                  this.rootSpisi.findIndex(
                    (p) => p.id_spis == this.moving_file.parentReference.id
                  ) != -1
                ) {
                  setTimeout(async () => {
                    this.resetFileView();
                  }, 200);
                  setTimeout(async () => {
                    this.routeToSpis(this.moving_file.parentReference.id);
                  }, 200);
                } else {
                  setTimeout(async () => {
                    this.resetFileView();
                  }, 200);
                }
              }
            });
        } else {
          if (i + 1 == this.multi_file_list.length && move_counter > 0) {
            this.multi_file_list = [];
            setTimeout(async () => {
              this.resetFileView();
            }, 200);
          }
        }
      }
    },
    folderHoverSpis(node) {
      this.spis_hovered = node;
      if (node == null) {
        $("#" + node.id_spis).removeClass("hovered-over");
        this.spis_hovered = node;
      } else {
        $("#" + node.id_spis).addClass("hovered-over");
      }
    },

    //dodajem klasu na upload wrapper da ga mogu lakše modificirati, jebem te vuetify
    uploadStyling() {
      this.newFilePop = true;
      setTimeout(function () {
        var upl = document.getElementById("main-file-upload");
        $(upl.parentElement.parentElement).addClass(
          "file-upload-dialog-wrapper"
        );
        $(upl.parentElement).addClass("main-file-upload-wrapper");
        $(upl.nextSibling).addClass("spis-megawrapper-parent");
        $(".spis-megawrapper").removeClass("active");
        $(".main-file-upload-wrapper").find(".spis-megawrapper:first").click();
      }, 100);
    },

    //RESET OF DATA VIEW
    async resetFileView() {
      this.newFilePop = false;
      // this.treemenu_counter++;
      // this.tree.nodes = [];
      this.treemenu_counter++;
      // if (this.$refs.treeViewer) {

      this.$refs["treeViewer"].resetFileView()
      //   this.$refs.treeViewer.resetFileView();
      // }
      this.filelist = [];
      let spis_id = this.all_files_rec.item.id;

      // let rec_data = await this.get_recursive_data(spis_id);
      // this.all_files_rec.children = rec_data;
      // this.all_files_rec = first_root;
    },

    // Add some visual fluff to show the user can drop its files
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-green-300");
        gsap.to(".loading-spinner", 0, { display: "block" });
        gsap.to(".loading-spinner", 0.5, { opacity: 1 });
        gsap.to(".drop-document-area", 0.5, {
          filter: "blur(3px)",
          opacity: 0.7,
        });
      }
    },
    // Clean up after cursor leaves
    dragleave(event) {
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
      gsap.to(".loading-spinner", 0.5, { opacity: 0 });
      gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
    },
    //EVENT following dropping the files in area
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
      //
      gsap.to(".loading-spinner", 0.5, { opacity: 0 });
      gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
    },
    // Reaction to event drop, that checks and controls all data
    onChange() {
      this.snackbar = false;
      //check all the inserted files and remove all that don't comply with pdf format START
      let tmp_file_list = [...this.$refs.file.files];
      let filt_tmp_file_list = tmp_file_list.filter(
        (file) => file.size < 57671680
      );
      const num_odbacenih = tmp_file_list.length - filt_tmp_file_list.length;
      if (num_odbacenih != 0) {
        this.snackbar = true;
        this.odbacene = tmp_file_list.filter((file) => file.size >= 57671680);
        this.snackText =
          "Zbog ograničenja Sharepoint-a odbačene su sljedeće datoteke veće od 55MB:";
      }
      tmp_file_list = filt_tmp_file_list;

      let pdf_tmp_file_list = tmp_file_list.filter((p) => {
        let tmp_name_list = p.name.split(".");
        let extens = tmp_name_list[tmp_name_list.length - 1].toLowerCase();
        return extens.includes("pdf") || extens.includes("zip");
      });
      //check all the inserted files and remove all that don't comply with pdf format END
      const len_dif = tmp_file_list.length - pdf_tmp_file_list.length;
      if (len_dif > 0) {
        this.odbacene = [];
        this.snackbar = true;
        this.snackText =
          "Odbačeno je " + len_dif + " datoteka koje nisu PDF formata.";
      }
      tmp_file_list = pdf_tmp_file_list;
      if ([...this.$refs.file.files].length)
        this.filelist = this.filelist.concat(tmp_file_list);
    },

    //Connection to api that sends all necessery identifications and nodes to sharepoint site onedrive

    //inside upload form set the folder id
    setUploadFolder(node) {
      this.selected_upload_folder = node.id;
    },

    async addNewUploadFile() {
      if (this.filelist.length != 0) {
        const formData = new FormData();
        this.filelist.forEach((fl) => {
          formData.append("files", fl);
        });

        if (!window.location.href.includes('archived-case')) {
          formData.append("token", this.accessToken);
        }
        formData.append("groupId", this.$route.params.uid);
        formData.append("sid", this.selected_upload_folder);
        formData.append(
          "log_msg",
          "Dodaje datoteke u spisu " +
            this.selected_spis.ime +
            " - broj datoteka:" +
            this.filelist.length
        );
        formData.append("logged_uid", this.$store.state.logged_in_user.uid);
        // formData.append("name", esc_filename);
        // appending file
        this.file_upload_text = "Uploading...";
        this.is_waiting_on_insert = true;

        await share
          .addDocumentInSpis(formData)
          .then(() => {
            this.is_waiting_on_insert = false;
            this.file_upload_text = "Upload";
            this.resetFileView();
            this.filelist = [];
            document.getElementById("assetsFieldHandle").value = "";
          })
          .catch((err) => {
            this.is_waiting_on_insert = false;
            this.file_upload_text = "Upload";
            this.filelist = [];

            document.getElementById("assetsFieldHandle").value = "";
          });
      }
    },
    //PUSH ROUTE TO CASE SPIS BASED ON ID
    routeToSpis(sid) {
      this.$router.push("/case/" + this.$route.params.uid + "/spisi/" + sid);
      this.activityFile = null;
    },
    deleteFileInSpis(file) {
      this.filelist = this.filelist.filter((f) => f != file);
    },
    // RETURN APPROPRIATE FILE ICON
    returnFileType(file_name) {
      var idx_ext = file_name.split(".").length - 1;
      var extension = file_name.split(".")[idx_ext].toLowerCase();
      var return_val = require("@/assets/img/doc_icon.svg");
      switch (extension) {
        case "docx":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "doc":
          return_val = require("@/assets/img/doc_icon.svg");
          break;
        case "pdf":
          return_val = require("@/assets/img/pdf_icon.svg");
          break;
        case "csv":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
        case "xls":
          return_val = require("@/assets/img/xls_icon.svg");
          break;
          case "zip":
          return_val = require("@/assets/img/zip-icon.svg");
          break;

        default:
          return_val = require("@/assets/img/doc_icon.svg");
          break;
      }
      return return_val;
    },
    //SWITCH TO NEW VIEW BY ROUTE
    switchTab(nastavak) {
      this.$router.push("/case/" + this.$route.params.uid + "/" + nastavak);
    },
  },
  mounted() {
    document.body.classList.add("spis-view");
  },
  destroyed() {
    document.body.classList.remove("spis-view");
    setTimeout(() => {
      $(window).off();
    }, 1700);
  },
};
</script>

<style></style>
